import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        regimeObligatoire: [
          entity?.parameters?.regimeObligatoire || null,
          Validators.required,
        ],
        beneficeNetAnnuel: [
          entity?.parameters?.beneficeNetAnnuel || null,
          Validators.required,
        ],
        fumeur: [
          !_.isNil(entity?.parameters?.fumeur)
            ? entity?.parameters?.fumeur
            : null,
          Validators.required,
        ],
        optionDosPsy: [
          !_.isNil(entity?.parameters?.optionDosPsy)
            ? entity?.parameters?.optionDosPsy
            : null,
          Validators.required,
        ],
        proprietaireResidencePrincipale: [
          !_.isNil(entity?.parameters?.proprietaireResidencePrincipale)
            ? entity?.parameters?.proprietaireResidencePrincipale
            : null,
          Validators.required,
        ],
        acquisitionResidencePrincipale: [
          entity?.parameters?.acquisitionResidencePrincipale || null,
        ],
        quotiteAssuranceEmprunt: [
          entity?.parameters?.quotiteAssuranceEmprunt || null,
        ],
        renteConjoint: [
          !_.isNil(entity?.parameters?.renteConjoint)
            ? entity?.parameters?.renteConjoint
            : null,
          Validators.required,
        ],
        renteEducationEnfants: [
          !_.isNil(entity?.parameters?.renteEducationEnfants)
            ? entity?.parameters?.renteEducationEnfants
            : null,
          Validators.required,
        ],
        preservationSalaireArretTravail: [
          !_.isNil(entity?.parameters?.preservationSalaireArretTravail)
            ? entity?.parameters?.preservationSalaireArretTravail
            : null,
          Validators.required,
        ],
        montantArretTravail: [
          entity?.parameters?.montantArretTravail || null,
        ],
        preservationSalaireInvalidite: [
          !_.isNil(entity?.parameters?.preservationSalaireInvalidite)
            ? entity?.parameters?.preservationSalaireInvalidite
            : null,
          Validators.required,
        ],
        montantInvalidite: [
          entity?.parameters?.montantInvalidite || null,
        ],
        tnsChargesProfessionnelles: [
          !_.isNil(entity?.parameters?.tnsChargesProfessionnelles)
            ? entity?.parameters?.tnsChargesProfessionnelles
            : null,
          Validators.required,
        ],
        montantChargesProfessionnelles: [
          entity?.parameters?.montantChargesProfessionnelles || null,
        ],
        avocatCollaborateur: [
          !_.isNil(entity?.parameters?.avocatCollaborateur)
            ? entity?.parameters?.avocatCollaborateur
            : null,
          Validators.required,
        ],
        dossiersPersonnels: [
          !_.isNil(entity?.parameters?.dossiersPersonnels)
            ? entity?.parameters?.dossiersPersonnels
            : null,
          Validators.required,
        ],
        notes: [
          entity?.parameters?.notes || null,
        ],
        // Analyse risque de cumul
        risqueDoubleIndemnisation: [
          !_.isNil(entity?.parameters?.risqueDoubleIndemnisation)
            ? entity?.parameters?.risqueDoubleIndemnisation
            : null,
          Validators.required,
        ],
        clientInformeRisqueCumul: [
          !_.isNil(entity?.parameters?.clientInformeRisqueCumul)
            ? entity?.parameters?.clientInformeRisqueCumul
            : null,
          Validators.required,
        ],
        justificationSouscription: [
          entity?.parameters?.justificationSouscription || [],
          Validators.required,
        ],
        justificationCommentaire: [
          entity?.parameters?.justificationCommentaire || null,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as FormArray;
  }

  extract() {
    return this.form.value.products;
  }
}
